import { CommonModule } from '@angular/common';
import { Component, effect, inject, signal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogShellComponent, FilledButtonComponent } from '@custom-components';
import {
  StatusChipComponent,
  StatusBadgeType,
} from '@custom-components/general/status-chip/status-chip.component';
import { DetailFieldComponent } from '@custom-components/general/detail-field';
import { DeviceStore } from '@root/app/store/device.store';
import { ReadoutStatus, StartReadoutData } from '@core/models';
import { TopologicalDeviceTelemetryStore } from '@root/app/store/topological-device-telemetry.store';

@Component({
  selector: 'xemex-device-readout-dialog',
  imports: [
    CommonModule,
    TranslateModule,
    DialogShellComponent,
    DetailFieldComponent,
    StatusChipComponent,
    FilledButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './device-readout-dialog.component.html',
})
export class DeviceReadoutDialogComponent {
  readonly deviceStore = inject(DeviceStore);
  readonly telemetryStore = inject(TopologicalDeviceTelemetryStore);
  readonly dialogRef = inject(MatDialogRef<DeviceReadoutDialogComponent>);
  public data = inject<StartReadoutData>(MAT_DIALOG_DATA);
  polId: string;
  readoutStatus: Signal<ReadoutStatus | undefined> = signal(undefined);

  constructor() {
    this.polId = this.data.polId;
    if (this.polId) {
      this.deviceStore.getReadoutStatus(this.polId);
      effect(() => {
        this.readoutStatus = this.deviceStore.readoutStatus;
        let status = this.readoutStatus()?.status;
        if (status != 'Success' && status != 'Failed') {
          this.deviceStore.getReadoutStatus(this.polId);
        } else if (status == 'Success') {
          this.telemetryStore.getDeviceTopologicalTelemetry({
            deviceId: this.data.deviceId,
            chartRange: this.telemetryStore.deviceChartTimeOption(),
            selectedDate: this.telemetryStore.selectedDate(),
          });
        }
      });
    }
  }

  statusType(status: string | undefined): StatusBadgeType {
    switch (status) {
      case 'Success':
        return 'success';
      case 'Failed':
        return 'error';
      default:
        return 'pending';
    }
  }
}
